// Fixed visible-chip threshold (Q1, non-binding — the ticket's "more than three").
// FUTURE: replace with a width-measurement pass (see chips.ts splitOverflow comment).
export const MAX_VISIBLE_CHIPS = 3;
